import type { ICaptureAnalyticsEventProps } from "@frontend-shared/product-analytics";
import { useCallback } from "react";

import { productAnalytics } from "@/lib/product-analytics";

interface IUseProductAnalyticsReturn {
  capture: (props: ICaptureAnalyticsEventProps) => void;
}

// NOTE: React entry point for emitting product analytics (epic NSAI-2431).
// The underlying client is a module singleton, so this hook exists for the
// call-site ergonomics — a stable `capture` that is safe in a dependency array
// — rather than to hold state.
//
// `props.event` is typed to `EAnalyticsEvent`, which is the point: a bare
// string can't reach PostHog, so web, mobile and the extension cannot drift
// into tracking the same concept under two different names.
export const useProductAnalytics = (): IUseProductAnalyticsReturn => {
  const capture = useCallback((props: ICaptureAnalyticsEventProps): void => {
    productAnalytics.capture(props);
  }, []);

  return { capture };
};
